define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll', 'load-more'],
    function ($, transit, modernizr, container, preloader, router, scroll, loadMoreFactory) {

        var module = (function () {

            var name = 'module-news-content';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            const loadMore = loadMoreFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                category: {
                    current: null
                }
            };

            view.startup = function () {

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.newsContentHeaderCls, 'animate__slideInDown', 'news-content', {});

                $(view.publicVars.cssId.anim.newsContentBoxCls).each(function (item) {
                    const id = container.getData($(this)[0], 'id');

                    scroll.registerAnimatedElement(view.publicVars.cssId.anim.newsContentBoxCls + id, 'animate__zoomIn', 'news-content', {});
                });

                view.privateVars.category.current = view.publicVars.category;

                loadMore.init(view.publicVars.loadMoreSetup);
                loadMore.setAdditionalParamCallback(view.methods.getCurrentCategory);
                loadMore.setSuccessCallback(view.methods.loadMoreSuccessCallback);
            };

            view.bind = function () {

            };

            view.methods = {

                getCurrentCategory: function () {
                    return view.privateVars.category.current;
                },

                loadMoreSuccessCallback: function (data, newCount) {
                    if(data.items && data.items.length > 0) {
                        data.items.forEach(function (item) {
                            scroll.registerAnimatedElement(view.publicVars.cssId.anim.newsContentBoxCls + item.id, 'animate__zoomIn', 'news-content', {});
                        });
                    }
                },

                setCallbacks: (callbacks) => {
                    view.privateVars.callbacks = callbacks;
                }
            };

            /* custom events */

            // pubSub.subscribe('view/updateCharacterContent', view.methods.updateCharacterContent);

            //pubSub.subscribe('view/updateSuccessLikes', view.methods.updateSuccessLikes);
            //pubSub.subscribe('view/updateSuccessViews', view.methods.updateSuccessViews);

            /* public methods */
            return {
                init: function (options, callbacks) {
                    view.methods.setCallbacks(callbacks);
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();


        return module;

    });